import t from "./index823.js";
import m from "./index815.js";
var r = "[object Symbol]";
function i(o) {
  return typeof o == "symbol" || m(o) && t(o) == r;
}
export {
  i as default
};
